import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CardContent from '@material-ui/core/CardContent';
import Countdown from 'react-countdown';
import styles from './migrate-timer.module.scss';
import MigrationBg from '../../../../../../../assets/images/migration-icon.svg';
import MigrationDarkBg from '../../../../../../../assets/images/migration-dark-icon.svg';
import OmIcon from '../../../../../../../assets/images/tokens/om.svg';
import Header from '../../../../../../../components/Stake/header';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import Timer from './timer';
import { getUntakedTime } from '../../../../../../../actions/om-stake-actions';

const MigrationCountdown = () => {
  const dispatch = useDispatch();
  const dark = useSelector((state) => state.basic.dark);
  const unstakedTime = useSelector((state) => state.OMstake.stake.unstakedTime);
  const colors = useGetTheme();

  const onComplete = async () => {
    setTimeout(() => {
      dispatch(getUntakedTime());
    }, 2000);
  };

  return (
    <>
      <Header icon={OmIcon} title='OM-Migration' />
      <CardContent
        style={{
          padding: '0',
          display: 'flex',
          position: 'relative',
          zIndex: 1,
          flexGrow: 1,
        }}
      >
        <div className={styles.container} style={{ color: colors.text }}>
          <div className={styles.title}>Migration Complete in</div>
          <Countdown date={unstakedTime * 1000} renderer={Timer} onComplete={() => onComplete()} />
          <img className={styles.image} src={dark ? MigrationDarkBg : MigrationBg} alt='' />
          <div className={styles.description}>
            You have successfully completed the first stage of the migration process, during which
            all unclaimed staking rewards have been migrated and staked on staking pool V2. In
            addition, you have initiated the 8 day unstaking process of OM V1 tokens from staking
            pool V1. Once the 8 day timer is finished, you will be ready to complete the second
            stage of the migration process.
          </div>
        </div>
      </CardContent>
    </>
  );
};

export default MigrationCountdown;
